import script from "./TelegramChatsSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TelegramChatsSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./TelegramChatsSkeleton.vue?vue&type=style&index=0&id=103eb982&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-103eb982"]])

export default __exports__